import { render, staticRenderFns } from "./oldGoldList.vue?vue&type=template&id=5e79de89&scoped=true&"
import script from "./oldGoldList.vue?vue&type=script&lang=js&"
export * from "./oldGoldList.vue?vue&type=script&lang=js&"
import style0 from "./oldGoldList.vue?vue&type=style&index=0&id=5e79de89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e79de89",
  null
  
)

export default component.exports